import React from "react";

const TourContext = React.createContext();

export default TourContext;
